import { AthleteOverviewSerieFilter } from "@/components/athlete-overview-page/serie-filter";
import { AthleteOverviewSponsorBanner } from "@/components/athlete-overview-page/sponsor-banner";
import { AthleteOverviewTable } from "@/components/athlete-overview-page/athlete-table";
import { AthleteOverviewProvider } from "@/components/athlete-overview-page/athlete-overview-page-provider";
import {
    AthleteOverviewPageViewProps
} from "@/components/athlete-overview-page/athlete-overview-page-view/types";
import { AthleteOverviewPodium } from "@/components/athlete-overview-page/athlete-podium";
import { AthleteTablePagination } from "@/components/athlete-overview-page/athlete-table-pagination";
import { AthleteDialog } from "../athlete-dialog";


export type { AthleteOverviewPageViewProps }

export function AthleteOverviewPageView(initialData: AthleteOverviewPageViewProps) {

    return (
        <AthleteOverviewProvider initial={initialData}>
            <AthleteDialog />
            <section className="bg-tinted-neutral w-full py-[25px] ">
                <div className="layout-container">
                    <AthleteOverviewSerieFilter />
                </div>
            </section>
            <div className="layout-container gap-10 pt-6 pb-10">
                <AthleteOverviewSponsorBanner />
                <AthleteOverviewPodium />
                <div>
                    <AthleteOverviewTable />
                    <AthleteTablePagination />
                </div>
                <AthleteOverviewSponsorBanner />
            </div>
        </AthleteOverviewProvider>
    )
}